import React from 'react'
import ReactDOM from 'react-dom/client'
// import App from './App.jsx'
import './index.css'
import RouterPage from './pages/RouterPage'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterPage />
  </React.StrictMode>,
)
